var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-image-container"},[_c('el-dialog',{attrs:{"visible":_vm.visible,"fullscreen":true,"show-close":true,"custom-class":"image-viewer-dialog"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"image-wrapper"},[_c('img',{style:({
          width: _vm.imageInfo.width + 'px',
          height: _vm.imageInfo.height + 'px'
        }),attrs:{"src":_vm.imageInfo.url},on:{"error":_vm.handleImageError}}),_c('i',{staticClass:"el-icon-close close-icon",on:{"click":_vm.close}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }